import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from './get-campaigns';

export type EditCampaignTagsRequest = {
  MarketingCampaignIds: number[];
  MarketingTagIds: number[];
};

export type EditCampaignTagsResponse = {
  message?: string;
  success: boolean;
};

export function useEditCampaignTagsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: EditCampaignTagsRequest) =>
      postData<EditCampaignTagsRequest, EditCampaignTagsResponse>({
        endpoint: 'api/marketing-campaign/edit-campaign-tags',
        payload,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: marketingCampaignsQueryKey });
    },
  });
}
